import { useContext } from 'react';

import { Context } from '../context';
import { useIsKnowledgeAgentSearchEnabled } from './useIsKnowledgeAgentSearchEnabled';
import { useStore } from '../zustand/stores';

export const useIsSitePickerEnabled = () => {
  const { isMobile, isTablet } = useContext(Context);
  const { isAiServicesDisabled } = useStore((state) => state.featureTogglesSlice);
  const isKnowledgeAgentSearchEnabled = useIsKnowledgeAgentSearchEnabled();

  if (isAiServicesDisabled || isMobile || isTablet) {
    return false;
  }

  return (
    isKnowledgeAgentSearchEnabled
  );
};
